import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmuRemoteComponentRenderer } from './directive/mmu-remote-component-renderer.directive';
import { MmuRemoteModuleService } from './service/mmu-remote-module.service';

@NgModule({
  declarations: [
    MmuRemoteComponentRenderer
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MmuRemoteComponentRenderer
  ]
})
export class MmuModuleFederationModule {
  constructor(private service: MmuRemoteModuleService) {}
}
